import { render, staticRenderFns } from "./NativeXIcon.vue?vue&type=template&id=b4141ce6&"
import script from "./NativeXIcon.vue?vue&type=script&lang=js&"
export * from "./NativeXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports